import { useState } from "react";
import axios from "axios";
import { Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NotifyForm = () => {
    const [email, setEmail] = useState("");
    const [state, setState] = useState("idle"); // idle | loading | done | error
    const [message, setMessage] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setState("loading");
        setMessage("");
        try {
            const { data } = await axios.post(`${API}/subscribe`, { email });
            setState("done");
            setMessage(
                data.status === "already_subscribed"
                    ? "You're already on the list."
                    : "You're on the list. We'll let you know when we launch."
            );
        } catch (err) {
            setState("error");
            setMessage(
                err.response?.status === 422
                    ? "Please enter a valid email address."
                    : "Something went wrong. Please try again."
            );
        }
    };

    if (state === "done") {
        return (
            <p
                data-testid="notify-success"
                role="status"
                className="font-body inline-flex items-center gap-2.5 text-sm tracking-wide text-[#89F337] md:text-base"
            >
                <Check className="h-4 w-4" strokeWidth={2.5} />
                {message}
            </p>
        );
    }

    return (
        <form
            data-testid="notify-form"
            onSubmit={submit}
            noValidate
            className="flex w-full flex-col gap-2 sm:w-auto"
        >
            <div className="flex w-full flex-col gap-2 sm:flex-row sm:items-center">
                <input
                    data-testid="notify-email-input"
                    type="email"
                    inputMode="email"
                    autoComplete="email"
                    required
                    placeholder="you@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="font-body w-full rounded-full border border-white/20 bg-white/5 px-5 py-4 text-sm tracking-wide text-[#F7F9F5] placeholder-[#708075] backdrop-blur-xl outline-none transition-colors duration-200 focus:border-[#89F337]/70 focus:bg-white/10 sm:w-64 sm:py-3.5"
                />
                <button
                    data-testid="notify-submit"
                    type="submit"
                    disabled={state === "loading" || !email}
                    className="font-display inline-flex w-full items-center justify-center rounded-full bg-[#89F337] px-7 py-4 text-sm font-bold tracking-[0.28em] uppercase text-[#050C08] transition-colors duration-200 hover:bg-[#9EFF52] active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto sm:py-3.5"
                >
                    {state === "loading" ? "Adding…" : "Notify Me"}
                </button>
            </div>
            {state === "error" && (
                <p
                    data-testid="notify-error"
                    role="alert"
                    className="font-body pl-1 text-xs tracking-wide text-[#FFB4A2]"
                >
                    {message}
                </p>
            )}
        </form>
    );
};
